<script setup lang="ts">
import { useSecurityPromptStore } from '@/stores/securityPrompt'
import AccountUpgradePopup from '@/components/security/AccountUpgradePopup.vue'
import BindPhonePopup from '@/components/security/BindPhonePopup.vue'
import SetPinPopup from '@/components/security/SetPinPopup.vue'
import type { SecurityPromptType } from '@/types/securityPrompt'

const securityPromptStore = useSecurityPromptStore()

function onPopupVisibilityChange(show: boolean) {
  if (!show && securityPromptStore.currentPrompt) {
    securityPromptStore.dismissCurrent()
  }
}

function onPromptCompleted(currentPrompt?: SecurityPromptType) {
  if (!currentPrompt && !securityPromptStore.currentPrompt) return
  securityPromptStore.onPromptCompleted(currentPrompt ?? securityPromptStore.currentPrompt!)
}
</script>

<template>
  <AccountUpgradePopup
    v-if="securityPromptStore.currentPrompt === 'account_upgrade'"
    :show="securityPromptStore.visible"
    @update:show="onPopupVisibilityChange"
    @completed="onPromptCompleted"
  />

  <SetPinPopup
    v-else-if="securityPromptStore.currentPrompt === 'set_pin'"
    :show="securityPromptStore.visible"
    @update:show="onPopupVisibilityChange"
    @completed="onPromptCompleted"
  />

  <BindPhonePopup
    v-else-if="securityPromptStore.currentPrompt === 'bind_phone'"
    :show="securityPromptStore.visible"
    @update:show="onPopupVisibilityChange"
    @completed="onPromptCompleted"
  />

  <!-- 实名认证：未实名时由 securityPrompt store 跳转 /user/verify-real -->
</template>
